var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    fill: "none",
    viewBox: "0 0 27 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#142C48",
    fillRule: "evenodd",
    d: "M13.5.333C6.133.333.167 6.07.167 13.15c0 5.67 3.816 10.46 9.116 12.159.667.112.917-.272.917-.609 0-.304-.017-1.313-.017-2.387-3.35.593-4.216-.785-4.483-1.506-.15-.368-.8-1.506-1.367-1.81-.466-.24-1.133-.833-.016-.849 1.05-.016 1.8.93 2.05 1.314 1.2 1.938 3.116 1.393 3.883 1.057.117-.833.467-1.394.85-1.714-2.967-.32-6.067-1.426-6.067-6.328 0-1.394.517-2.547 1.367-3.445-.133-.32-.6-1.634.133-3.396 0 0 1.117-.336 3.667 1.314a12.8 12.8 0 0 1 3.333-.433c1.134 0 2.267.144 3.334.433 2.55-1.666 3.666-1.314 3.666-1.314.734 1.762.267 3.076.134 3.396.85.898 1.366 2.035 1.366 3.445 0 4.918-3.116 6.007-6.083 6.328.483.4.9 1.17.9 2.37 0 1.715-.017 3.093-.017 3.525 0 .337.25.737.917.609 2.647-.859 4.947-2.494 6.576-4.675a12.5 12.5 0 0 0 2.507-7.484C26.833 6.069 20.867.333 13.5.333",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.7d90f0db5a9c3c6e4542fc5e4c1ac213.svg";
export { ForwardRef as ReactComponent };